<template>
    <div ref="footerWrapper" class="footerWrapper" :style="cssVars">
      <div v-if="topBlock.status" ref="topBlock" class="top blue_block">
        <div class="container_sm">
          <div class="title_f">
            Folge uns
            <a target='_blank' href='https://www.instagram.com/philipstelevision/'>@philipstelevision</a>
            <img class="instagram-img" src="https://jolt-assets.s3.eu-central-1.amazonaws.com/template/instagram-logo-white.png" alt="Insta">
          </div>
        </div>
      </div>
      <div class="bottom container" v-if="columnList.length">
        <a class="navbar-brand mx-0" :href="logo.url">
          <img :style="logo.styles" :src="logo.src" alt="Brand Logo" />
        </a>
        <div class="linksWrapper">
          <div
            v-for="(list, listIndex) in columnList"
            :key="`columnlinkGroup_${listIndex}`"
            class="linkGroupWrapper"
          >
            <h3
              v-if="list.title"
              class="linkGroupTitle"
              v-html="$t(list.title)"
            ></h3>
            <ul class="links">
              <li v-for="(link, i) in list.fields" :key="`${link.id}_${i}`" :style="link.styles">
                <component
                  v-bind:is="link.fieldType"
                  v-bind="link.properties"
                  :data-field-id="link.fieldId"
                  :fieldId="link.fieldId"
                  :data-field-type="link.fieldType"
                />
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="footer-links my-3">
          <a style="margin-right: 15px;" href="https://www.facebook.com/PhilipsSound/" target="_blank" rel="noopener noreferrer" aria-label="Facebook Link">
            <img src="https://jolt-assets.s3.eu-central-1.amazonaws.com/template/facebook-icon-white.png" alt="Facebook">
          </a>
          <a href="https://www.instagram.com/philipssound/" target="_blank" rel="noopener noreferrer">
            <img src="https://jolt-assets.s3.eu-central-1.amazonaws.com/template/instagram-icon-white.png" alt="Instagram">
          </a>
        </div> -->
        <paragraph
          :grid="{ columns: 12 }"
          :text="copyright.text"
          :styles="copyright.styles"
          class="mb-5"
         />
      </div>
    </div>
</template>

<script>
import componentRenderer from "@/components/component-renderer";
import paragraph from "./paragraph";

export default {
  name: "footer-component",
  components: {
    componentRenderer,
    paragraph
  },
  props: {
    background: {
      type: String,
      default: "#000"
    },
    topBlock: {
      type: Object,
      default: () => {
        return {
          status: true,
          background: '#000'
        }
      }
    },
    foreground: {
      type: String,
      default: "#fff"
    },
    columnList: {
      type: Array,
      required: false,
      default: () => []
    },
    rowList: {
      type: Array,
      required: false,
      default: () => []
    },
    logo: {
      required: true,
      type: Object
    },
    sectionId: {
      type: [Number, String],
      required: false
    },
    isFromBuilder: {
      type: Boolean,
      required: false
    },
    copyright: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    this.$refs.footerWrapper.parentNode.style.background = this.background;
    if (this.topBlock.status)
      this.$refs.topBlock.style.background = this.topBlock.background;
  },
  computed: {
    cssVars () {
      return {
        '--color': this.color
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1500px !important;
}
.blue_block {
  padding: 20px 0;

  .container_sm {
    text-align: center;
  }

  .title_f {
    font-size: 1.4rem;
    color: rgb(255, 255, 255);
    font-weight: 600;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .instagram-img {
    margin-left: 15px;
  }
}
.footerWrapper {
  padding-top: 88px;

  .socialMediaWrapper {
    display: flex;
    align-items: flex-start;
    min-height: 50px;
    margin-top: 25px;
    @media (max-width: 767px) {
      margin-left: 113px;
    }
    .socialMediaText {
      color: #fff;
      margin-left: 5px;
      margin-right: 35px;
      @media (max-width: 600px) {
        display: none;
      }
    }
    .socialMediaIconsWrapper {
      display: flex;
      flex-direction: row;
      flex-flow: wrap;
      @media (min-width: 768px) {
        flex-direction: column;
      }
      @media (min-width: 992px) {
        flex-direction: row;
        margin-top: -7px;
      }
      .socialMediaIcon {
        margin: 5px 5px 10px 5px;
        img {
          width: 28px;
          height: 28px;
        }
      }
    }
  }
  hr {
    border-top: 1px solid #97d700;
    margin-top: 45px;
    margin-bottom: 34px;
  }
  .top {
    .linksWrapper {
      .linkGroupWrapper {
        width: 100%;
        .linkGroupTitle {
          font-size: 14px;
          padding: 0;
          margin: 0 10px 0 0;
        }
        .bottomLinks {
          list-style: none;
          display: flex;
          flex-direction: row;
          @media (max-width: 768.97px) {
            flex-flow: wrap;
            justify-content: center;
          }
          div {
            font-size: 12px;
            padding-left: 8px;
            padding-right: 8px;
            &:not(:first-child) {
              border-left: 1px solid #fff;
            }
            &:first-child {
              padding-left: 0;
            }
          }
        }
      }
    }
  }

  .bottom {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .linksWrapper {
      padding-top: 25px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .linkGroupWrapper {
        // width: 100%;
        .linkGroupTitle {
          text-align: left;
          font-size: 18px;
          font-weight: normal;
          margin-bottom: 13px;
          margin-top: 10px;
        }
        .links {
          display: flex;
          justify-content: space-around;
          list-style: none;
          padding: 0;
          margin-bottom: 0;
          margin: 10px 20px;
          a {
            font-size: 14px;
            line-height: 24px;
            font-weight: 350;
            margin: 5px 15px;
            color: var(--color);
            &:hover {
              color: var(--par-color);
            }
          }
          p {
            font-size: 12px;
            line-height: 21px;
            font-weight: 350;
          }
          @media (max-width: 767px) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 10px;
          }
        }
      }
    }
  }
  .mobileCopyright {
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 12px;
    font-weight: bold;
    /*margin-top: 5px;*/
    @media (min-width: 425.97px) {
      justify-content: flex-start;
      /*margin-left: 10px;*/
    }
  }
  .wrapper-copyrighting {
    display: flex;
    justify-content: flex-end;
    margin-top: 35px;
    align-items: center;
  }
  .wrapper-copyrighting-image {
    width: 50px;
    min-width: 50px;
  }
  .copyrighting-image {
    width: 100%;
  }
  .copyrighting-text {
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    &__copyright {
      font-size: 14px;
      font-weight: 600;
    }
    &__description,
    &__description-with-link {
      font-size: 12px;
    }
    &__description-with-link {
      a {
        text-decoration: underline;
        &:hover {
          color: white;
        }
      }
    }
  }
  .search-icon {
    cursor: pointer;
  }
}
</style>
